exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Divider__divider{border-left:3px solid #43BA85;height:100%}.Divider__divider.Divider__dark{border-left-color:#004B3D}\n", "", {"version":3,"sources":["/home/runner/work/gl-web-react-ui/gl-web-react-ui/web/js/content/packages/ETSetupWalkthrough/common/Divider.scss"],"names":[],"mappings":"AAAA,kBAAS,8BAA8B,WAAW,CAAC,gCAAc,yBAAyB,CAAC","file":"Divider.scss","sourcesContent":[".divider{border-left:3px solid #43BA85;height:100%}.divider.dark{border-left-color:#004B3D}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"divider": "Divider__divider",
	"dark": "Divider__dark"
};